import { ChapterHeading, Reveal } from "./Reveal";
import { ContactButtons, GMB_URL, CALL_URL, PHONE_DISPLAY } from "./ContactButtons";
import { ArrowUpRight } from "lucide-react";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative overflow-hidden border-t border-white/5 bg-[#0b0b0d]">
    <div
      className="pointer-events-none absolute -top-40 left-1/2 h-[480px] w-[720px] -translate-x-1/2 rounded-full opacity-20 blur-3xl"
      style={{ background: "radial-gradient(ellipse, #C5A059 0%, transparent 65%)" }}
    />
    <div className="relative mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
      <ChapterHeading number="05" label="Arrive" testId="contact-chapter" />

      <Reveal>
        <h2 className="max-w-3xl font-serif text-5xl leading-[1.02] tracking-tight text-[#F5F5F0] sm:text-6xl lg:text-7xl">
          Come home to <em className="font-light italic text-[#C5A059]">Kashi</em>.
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="mt-8 max-w-xl text-base leading-loose text-[#A1A1AA] md:text-lg">
          Message the house on WhatsApp for dates and honest rates, or call
          ahead and let the family know you&rsquo;re coming. The lanes are easier
          with a friend waiting at the end of them.
        </p>
      </Reveal>

      <Reveal delay={0.25} className="mt-12">
        <ContactButtons idPrefix="contact" />
      </Reveal>

      <Reveal delay={0.3} className="mt-6">
        <p data-testid="contact-phone-display" className="text-sm text-[#A1A1AA]">
          Reach the house directly at{" "}
          <a href={CALL_URL} className="font-semibold text-[#F5F5F0] transition-colors hover:text-[#C5A059]">
            {PHONE_DISPLAY}
          </a>
        </p>
      </Reveal>

      <Reveal delay={0.35} className="mt-10">
        <a
          data-testid="contact-gmb-link"
          href={GMB_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#A1A1AA] transition-colors hover:text-[#C5A059]"
        >
          Find us on Google Maps
          <ArrowUpRight className="h-4 w-4" />
        </a>
      </Reveal>
    </div>
  </section>
);
